import { combineReducers } from 'redux';
import nftReducer from './nfts';
import authorListReducer from './authorList';
import filterReducer from './filters';
import mapImagesReducer from '../slices/mapImagesSlice';
import statusReducer from '../slices/statusSlice';
import openModalNftDetailsReducer from './openModalNftDetailsReducer';
import nftDetailsReducer from './nftDetailsReducer';
import notificationsReducer from './notifications';
import loadingReducer from './loadingReducer';
import userReducer from './user';
import cartReducer from '../slices/cartSlice';

export const rootReducer = combineReducers({
  NFT: nftReducer,
  authors: authorListReducer,
  filters: filterReducer,
  mapImagesLoaded: mapImagesReducer,
  gameStatus: statusReducer,
  openModalNftDetails:openModalNftDetailsReducer,
  NftDetails:nftDetailsReducer,
  notifications: notificationsReducer,
  loadings: loadingReducer,
  user: userReducer,
  cart: cartReducer,
});

const reducers = (state, action) => rootReducer(state, action);

export default reducers;